import { Link } from 'react-router-dom';
import "./NotFound.css"
import Navbar from './Navbar';
import { useEffect } from 'react';

const NotFound = () => {
      useEffect(() => {
        const scrollToTop = () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        scrollToTop()
      }, [])
    return (
        <div className='min-height'>
            <Navbar />
            <div className='notfound'>
                <h1>404 - Stránka nenalezena</h1>
                <p>Omlouváme se, ale tato stránka neexistuje.</p>
                <Link to="/" style={{ textDecoration: 'none', color: 'blue', fontSize: '18px' }}>
                    Zpět na hlavní stránku
                </Link>
            </div>
        </div>
    );
};

export default NotFound;